// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion__trigger[data-v-5bcaf649]{display:flex;justify-content:space-between}.accordion-enter-active[data-v-5bcaf649],.accordion-leave-active[data-v-5bcaf649]{will-change:height,opacity;transition:height .3s ease,opacity .3s ease;overflow:hidden}.accordion-enter[data-v-5bcaf649],.accordion-leave-to[data-v-5bcaf649]{height:0!important;opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
